import { AgentIssueChat } from '../../_shared/AgentIssueChat';

export { SUPPORT_TICKET_CREATED_EVENT } from '../../_shared/AgentIssueChat';

const SUPPORT_AGENT = 'support-agent';

/** Support chat: one agent that classifies the request as a bug or a need and files the issue. */
export function SupportChatContent() {
  return <AgentIssueChat source="support" agentId={SUPPORT_AGENT} placeholder="Describe your issue..." />;
}
